import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  redNegative: {
    color: theme.palette.error.main,
  },
}));

function getFractionDigitsFor(number) {
  // TODO the strict zero comparison is probably too strict for floating point numbers?
  if (number - Math.floor(number) !== 0) {
    return 2;
  } else {
    return 0;
  }
}

export function signedMoney(amount) {
  if (amount >= 0) {
    return '+' + moneyFormat(amount);
  }

  return '-' + moneyFormat(amount);
}

/**
 * Like moneyFormat, but without the currency sign (e.g. if the currency sign is supplied elsewhere)
 */
export function numberFormat(amount) {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: getFractionDigitsFor(amount),
  });
  return formatter.format(amount);
}

/**
 * By default, formats whole numbers without decimals (cents) and non-whole numbers with two decimals.
 * If you include the `fractionDigits` arguments, formats all values with exactly that many decimals (good for vertical alignment).
 */
export function moneyFormat(amount, fractionDigits = undefined) {
  const minimumFractionDigits = fractionDigits ?? getFractionDigitsFor(amount);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
  });

  return formatter.format(amount);
}

export function percentFormat(percent) {
  return percent + '%';
}

export function moneyParseToNumber(str) {
  return Number(str.replace(/[^\d.]/g, ''));
}

export function takePercent(base, percent) {
  const decimalPercent = percent * 0.01;
  return base * decimalPercent;
}

export function addPercent(base, percent) {
  const decimalPercent = percent * 0.01;
  return base + base * decimalPercent;
}

export function subtractPercent(base, percent) {
  const decimalPercent = percent * 0.01;
  return base - base * decimalPercent;
}

/**
 * By default, displays whole numbers without decimals (cents) and non-whole numbers with two decimals.
 * If you pass the `full` flag, always displays the value with 2 decimal places (good for vertical alignment).
 */
export default function Money({
  className = undefined,
  style = undefined,
  prefix = undefined,
  postfix = undefined,
  value,
  full = false,
  redNegative = false,
}) {
  const classes = useStyles();
  const formattedValue = full ? moneyFormat(value, 2) : moneyFormat(value);

  return (
    <span
      className={clsx({
        [className]: !!className,
        [classes.redNegative]: redNegative && value < 0,
      })}
      style={style}
    >
      {prefix != null && prefix}
      {formattedValue}
      {postfix != null && postfix}
    </span>
  );
}
